/**
 * Ported verbatim from the prototype's script block (SK Hospitality.dc.html lines 985-1009).
 * Every screen needs the exact same tone colors, icon paths, and status vocabulary as the mockup.
 */

export type Tone = 'info' | 'success' | 'warn' | 'accent' | 'orange' | 'danger' | 'neutral' | 'purple';

export const TONE: Record<Tone, string> = {
  info: '#4EA7FC', success: '#4CB782', warn: '#DEB949', accent: '#2D5CF6',
  orange: '#F0883E', danger: '#EB5757', neutral: '#8A8F98', purple: '#B59AFF',
};

export const SOFT: Record<Tone, string> = {
  info: 'rgba(78,167,252,.14)', success: 'rgba(76,183,130,.14)', warn: 'rgba(222,185,73,.16)',
  accent: 'rgba(45,92,246,.12)', orange: 'rgba(240,136,62,.15)', danger: 'rgba(235,87,87,.13)',
  neutral: 'rgba(138,143,152,.14)', purple: 'rgba(181,154,255,.16)',
};

export const ICONS: Record<string, string> = {
  home: 'M3 11l9-8 9 8M5 10v11h14V10', grid: 'M4 6h16M4 12h16M4 18h16',
  calendar: 'M3 5h18v16H3zM3 9h18M8 3v4M16 3v4', check: 'M5 12l5 5L20 7',
  bell: 'M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9M10 21a2 2 0 0 0 4 0',
  phone: 'M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6 19.8 19.8 0 0 1-3.1-8.7A2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1 1 .3 2 .7 3a2 2 0 0 1-.5 2L8 10a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2-.5c1 .4 2 .6 3 .7a2 2 0 0 1 1.7 2z',
  users: 'M2 21c0-4 3-6 7-6s7 2 7 6M9 12a4 4 0 1 1 0-8 4 4 0 0 1 0 8zM17 14c3 0 6 2 6 6M17 11a3 3 0 1 0 0-6',
  user: 'M4 21c0-4 4-7 8-7s8 3 8 7M12 12a4 4 0 1 1 0-8 4 4 0 0 1 0 8z',
  star: 'M12 3l3 6.5 7 1-5 5 1.2 7L12 19l-6.2 3.5L7 15l-5-5 7-1z',
  mail: 'M3 6h18v12H3zM3 6l9 7 9-7', arrowr: 'M5 12h14m-6-6 6 6-6 6',
  truck: 'M3 7h11v8H3zM14 10h4l3 3v2h-7zM7 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM18 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4z',
  receipt: 'M5 3h14v18l-3-2-2 2-2-2-2 2-2-2-1 2zM8 8h8M8 12h8M8 16h5',
  rupee: 'M7 4h10M7 9h10M14 4c0 5-4 5-7 5l7 7', clock: 'M12 7v5l3 2M12 21a9 9 0 1 1 0-18 9 9 0 0 1 0 18z',
  x: 'M6 6l12 12M18 6 6 18', plus: 'M12 5v14M5 12h14', minus: 'M5 12h14',
  combine: 'M8 7H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h3M16 7h3a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-3M9 12h6',
  broom: 'M19 5l-7 7M12 12l-3 8-5-5 8-3M12 12l-2-2', info: 'M12 21a9 9 0 1 1 0-18 9 9 0 0 1 0 18zM12 8v.01M12 11v5',
  warn: 'M12 3 2 21h20L12 3zM12 10v4M12 18v.01', agent: 'M12 2a5 5 0 0 1 5 5v3a5 5 0 0 1-10 0V7a5 5 0 0 1 5-5zM4 20c0-3 4-5 8-5s8 2 8 5',
  qr: 'M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4zM14 14h2v2h-2zM18 14h2v2h-2zM14 18h2v2h-2zM18 18h2v2h-2z',
  chat: 'M21 12a8 8 0 0 1-11.5 7.2L4 21l1.8-5.5A8 8 0 1 1 21 12z', whatsapp: 'M21 12a8 8 0 0 1-11.5 7.2L4 21l1.8-5.5A8 8 0 1 1 21 12z',
  pin: 'M12 21s7-7 7-12a7 7 0 1 0-14 0c0 5 7 12 7 12zM12 9a2 2 0 1 0 0 4 2 2 0 0 0 0-4z',
  settings: 'M12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM19.4 13a1.7 1.7 0 0 0 .3 1.9l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-2.9 1.2V21a2 2 0 0 1-4 0v-.1A1.7 1.7 0 0 0 7 19.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0-1.2-2.9H3a2 2 0 0 1 0-4h.1A1.7 1.7 0 0 0 4.7 7l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.9.3H9.5A1.7 1.7 0 0 0 10.6 3V3a2 2 0 0 1 4 0v.1a1.7 1.7 0 0 0 2.9 1.2l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.9v.1a1.7 1.7 0 0 0 1.5 1H21a2 2 0 0 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z',
  logout: 'M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9',
};

/** Sidebar theme-toggle icon — the prototype always shows this fixed moon glyph, it does not swap by theme. */
export const THEME_TOGGLE_ICON_D = 'M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9z';

export type TableStatus = 'free' | 'reserved' | 'seated' | 'dirty';

export const STATUS: Record<TableStatus, string> = {
  free: '#4CB782', reserved: '#4EA7FC', seated: '#F0883E', dirty: '#EB5757',
};

export const STATUS_LABEL: Record<TableStatus, string> = {
  free: 'Free', reserved: 'Reserved', seated: 'Seated', dirty: 'Needs bussing',
};
